import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-electric/10 bg-navy py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-162" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-163" data-mp="2vowimdnevsxs">
        <div className="text-center" data-id="element-164" data-mp="39hm9owhsro1r">
          <SectionHeading id="problem-title" data-id="element-165" data-mp="39gkuqgxnuher">Does This Sound Familiar?</SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-white" data-id="element-166" data-mp="35f95icip7y73">
            Sunday at 11 p.m. Tomorrow you teach electrical engineering. You're still searching for the best way to
            explain fundamentals, circuits, machines, and power systems without losing students' attention.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-electric/25 bg-panel p-6 shadow-lg shadow-black/30 sm:p-8" data-id="element-167" data-mp="1p455gvf9h7ax">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-bold text-white" data-id="element-168" data-mp="sdjllhxwqqow">
            <AlertTriangleIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-169" data-mp="x4ry4mujas6a" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-170" data-mp="122tf928eghf4">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-ink" data-id="element-171" data-mp="1726buep2p2uw">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-electric" aria-hidden="true" data-id="element-172" data-mp="1c2281rrj3pzw" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-173" data-mp="3dt5ioh1f54kg">
          <p className="text-lg font-bold text-white" data-id="element-174" data-mp="3du767kzmfjj2">
            Stop wasting personal time. You're already dedicated. What you need is the right tool.
          </p>
          <p className="mt-3 text-3xl font-bold tracking-tight text-gold sm:text-4xl" data-id="element-175" data-mp="p00m1tj6lt0p">Plan your entire year today.</p>
        </div>
      </div>
    </section>;
}